"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetFullKeyEndpointFromExisting = createGetFullKeyEndpointFromExisting;
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
function createGetFullKeyEndpointFromExisting(endpoint, count = 100) {
    return (request) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield endpoint(Object.assign(Object.assign({}, request), { count, paginationDirection: sonar_ts_types_1.PaginationDirection.Forward }));
        if (!response.data) {
            return response;
        }
        const results = [...response.data.results];
        while ((_a = response.data) === null || _a === void 0 ? void 0 : _a.nextKey) {
            // eslint-disable-next-line no-await-in-loop
            response = yield endpoint(Object.assign(Object.assign({}, request), { count, key: response.data.nextKey, paginationDirection: sonar_ts_types_1.PaginationDirection.Forward }));
            if (response.data) {
                results.push(...response.data.results);
                response.data.results = results;
                response.data.prevKey = undefined;
            }
        }
        return response;
    });
}
//# sourceMappingURL=createGetFullKeyEndpointFromExisting.js.map